/* eslint-disable no-useless-escape */
/* eslint-disable no-trailing-spaces */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */

// This utils file should contain all utility functions
// functions can then be called using utils.someFunc() from within scripts.js

import moment from 'moment';
import validate from 'validate.js';
import {CDC_ERROR_CODE, CDC_ERROR_MESSAGE} from './constants';
import _ from 'lodash';

export function isOnMobile() {
	return window.innerWidth < 992;
}

export function isOnMobileSmaller() {
	return window.innerWidth < 768;
}

export function formValidation(form, C, errorCB) {
    // declare constraints
    let constraints = {};
    let inputs = form.querySelectorAll('input, textarea, select');

    // Before using it we must add the parse and format functions
	// Here is a sample implementation using moment.js
	// validate.extend(validate.validators.datetime, {
	// 	// The value is guaranteed not to be null or undefined but otherwise it
	// 	// could be anything.
	// 	parse: function(value, options) {
    //         let format = options.dateOnly ? 'DD-MM-YYYY' : 'DD-MM-YYYY hh:mm:ss';
	// 		return +moment(value, format);
	// 	},
	// 	// Input is a unix timestamp
	// 	format: function(value, options) {
    //         let format = options.dateOnly ? 'DD-MM-YYYY' : 'DD-MM-YYYY hh:mm:ss';
	// 		return moment(value, format).format(format);
	// 	},
    // });

    // remove attribute from the error message
    validate.options = {
        fullMessages: false,
    };

    validate.validators.equality.options = {
        message: 'The confirmation value doesn\'t match',
    };

    // validate.validators.email.options = {
    //     message: 'Please enter a valid email address',
    // };

    for (let input of inputs) {
        let validationObj = $(input).data('validation');
        let attribute = $(input).attr('name');
		// trigger validate for confirm password
		let targetName = $(input).attr('data-target');
		targetName && $(input).change(function() {
            $(`[name="${targetName}"]`).val() && triggerDispatchEvent($(`[name="${targetName}"]`), 'change');
		});
        if (validationObj && attribute) {
            let rules = validationObj.rules;
            let required = validationObj.required;

            if (required) {
                constraints[attribute] = {
                    presence: {
						message: validationObj.requiredMsg || 'This field is required',
						allowEmpty: false,
                    },
                };
            } else {
                constraints[attribute] = {
                    presence: false,
                };
            }

            if (rules && rules.length > 0) {
                for (let i = 0; i < rules.length; i++) {
                    let ruleObj = rules[i];
                    let otherField = ruleObj.otherField;
                    let otherFieldsStatus = false;
                    switch (ruleObj.rule) {
						case 'egift-amount':
							constraints[attribute].format = function(value, attributes, attributeName, options, constraints) {
								const $customAmount = $(`[name=${attributeName}]`);
								const _minValue = parseInt($customAmount.data('minValue')) || 0;
								const _maxValue = parseInt($customAmount.data('maxValue')) || 1000;
								const _message = $customAmount.data('errorMsg');
								// Select custom amount
								if (!(/^(?!(0))[0-9]+$/).test(value)) {
									return {
                                        pattern: /(.*?)/,
                                        message: 'Please enter a valid number',
                                    };
								} else if (value < _minValue || value > _maxValue) {
									return {
                                        pattern: /(.*?)/,
                                        message: _message,
                                    };
								}
							};
							break;
                        case 'mobile-number':
							constraints[attribute].format = function(value, attributes, attributeName, options, constraints) {
                                if ((/^0064[0-9]*$/).test(value)) {
                                    value = value.replace('0064', '0');
                                    $(input).val(value);
                                }

                                if (!(/^[a-zA-Z0-9]*$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Please remove any special characters'
                                    };
                                } else if (!(/^[0-9]*$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Please enter a valid phone number'
                                    };
                                } else if (!(/^0[0-9]*$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Phone number should begin with 0'
                                    };
                                } else if (!(/^(02|03|04|06|07|09)[0-9]*$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Please enter a valid mobile or landline number'
                                    };
                                } else if ((/^02[0-9]*$/).test(value) && !(/^.{9,15}$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Phone should be within 7 and 13 numbers after the prefix 02'
                                    };
                                } else if (!(/^02[0-9]*$/).test(value) && !(/^.{9}$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: `Phone should be 7 numbers after the prefix ${value.slice(0, 2)}`
                                    };
                                }

								return false;
							};

							break;

                            case 'mobile-number-cdc':
                                constraints[attribute].format = function(value, attributes, attributeName, options, constraints) {

                                if (!(/^[a-zA-Z0-9]*$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Please remove any special characters',
                                    };
                                } else if (!(/^[0-9]*$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Please enter a valid phone number',
                                    };
                                } else if (!(/^0[0-9]*$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Phone number should begin with 0',
                                    };
                                } else if ((/^0[0-9]*$/).test(value) && !(/^.{7,12}$/).test(value)) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'Phone should be within 7 and 12 numbers',
                                    };
                                }

                                return false;
                            };

                            break;

                        case 'email':
                            constraints[attribute].format = {
                                pattern: ruleObj.regex || /^(?!.*\.\@)(?!.*[.!#$%&'*+/=?^_`{|}~-]{2})(?!.*[.!#$%&'*+/=?^_`{|}~-]$)(?!^[.!#$%&'*+/=?^_`{|}~-])[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/,
                                message: 'Please enter a valid email address',
							};
							break;
						case 'email2':
							constraints[attribute].format = {
								pattern: ruleObj.regex || /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/,
								message: 'Please enter a valid email address',
							};
						break;
						case 'equalEmail':
                            constraints[attribute].equality = {
                                attribute: ruleObj.attribute || '',
								message: 'Email address is not matching',
                            };
                            break;
                        case 'equalTo':
                            constraints[attribute].equality = {
                                attribute: ruleObj.attribute || '',
                            };
                            break;
                        case 'password':
							constraints[attribute].format = function(value, attributes, attributeName, options, constraints) {
								if (value) {
									if (!(/^.{8,}$/).test(value)) {
                                        return {
											pattern: /(.*?)/,
                                            message: 'The password you entered does not meet the minimum length of 8 characters. Please enter a valid password.',
                                        };
                                    } else if (!(/^.{8,64}$/).test(value)) {
                                        return {
											pattern: /(.*?)/,
                                            message: 'The password you entered exceeds the maximum length of 64 characters. Please enter a valid password.',
                                        };
                                    } else if (!(/(?=.*[A-Z])/).test(value)) {
										return {
											pattern: /(.*?)/,
											message: 'The password you entered does not contain at least one uppercase letter. Please enter a valid password.',
										};
									} else if (!(/(?=.*[a-z])/).test(value)) {
										return {
											pattern: /(.*?)/,
											message: 'The password you entered does not contain at least one lowercase letter. Please enter a valid password.',
										};
									} else if (!(/(?=.*\d)/).test(value)) {
										return {
											pattern: /(.*?)/,
											message: 'The password you entered does not contain at least one number. Please enter a valid password.',
										};
									} else if (!(/(?=.*[!@#$%^&*])/).test(value)) {
                                        return {
                                            pattern: /(.*?)/,
                                            message: 'The password you entered does not contain at least one special character. Please enter a valid password.',
                                        };
                                    }
								}
								return false;
							};
                            break;
                        case 'phone':
                            constraints[attribute].format = {
                                pattern: ruleObj.regex || /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/,
                                message: 'Please enter a valid phone number',
                            };
                            break;
                        case 'number':
                            constraints[attribute].format = {
                                pattern: ruleObj.regex || /^[0-9]+$/,
                                message: 'Please enter a valid number',
                            };
                            break;
                        case 'custom_store_search':
                            constraints[attribute].format = {
                                pattern: ruleObj.regex || /.+$/,
                                message: 'Please select a store for collection',
                            };
                            break;
                        case 'creditCardNumber':
                            constraints[attribute].format = {
                                pattern: ruleObj.regex || /^(34|37|4|5[1-5]).*$/,
                                message: function(value, attribute, validatorOptions, attributes, globalOptions) {
                                    return validate.format('Please enter a valid credit card number', {
                                        num: value,
                                    });
                                },
                            };
                            constraints[attribute].length = function(value, attributes, attributeName, options, constraints) {
                                if (value) {
                                    // Amex
                                    if ((/^(34|37).*$/).test(value)) {
                                        return {
                                            is: 15,
                                            message: 'Card number should be 15 characters for this card type',
                                        };
                                    }
                                     // Visa, Mastercard
                                     if ((/^(4|5[1-5]).*$/).test(value)) {
                                        return {
                                            is: 16,
                                            message: 'Card number should be 16 characters for this card type',
                                        };
                                     }
                                }
                                // Unknown card, don't validate length
                                return false;
                              };
                            break;
                        case 'date':
							constraints[attribute].format = function(value, attributes, attributeName, options, constraints) {
								if (value && !moment(value, 'DD-MM-YYYY', true).isValid()) {
									return {
										pattern: /(.*?)/,
										message: 'Please enter a valid date',
									};
								} else {
									return false;
								}
							};
							break;
                        case 'postcode':
                            constraints[attribute].format = function(value, attributes, attributeName, options, constraints) {
                                let countryAttr = ruleObj.countryAttribute;
                                let country = $('[name="'+ countryAttr +'"]').val();
                                // nz or aus
                                if (country == 'NZ' || country == 'AU' || country == 'AUS' || country == 'NZL') {
                                    return {
                                        pattern: ruleObj.regex || /^(?!.*0000)[0-9]{0,4}$/,
                                        message: 'Please enter a valid postcode',
                                    };
                                } else {
                                    // not nz or aus, don't validate digits only
                                    return false;
                                }
                                // other countries?
                            };
                            constraints[attribute].length = function(value, attributes, attributeName, options, constraints) {
                                let countryAttr = ruleObj.countryAttribute;
                                let country = $('[name="' + countryAttr + '"]').val();
                                // nz or aus
                                if (country == 'NZ' || country == 'AU' || country == 'AUS' || country == 'NZL') {
                                    return {
                                        is: 4,
                                        message: 'Please enter a valid postcode',
                                    };
                                } else {
                                    // not nz or aus, don't validate length
                                    return false;
                                }
                                // other countries?
                            };
                            break;
                        case 'requiredIfCity':
                            constraints[attribute].presence = function(value, attributes, attributeName, options, constraints) {
                                let countryAttr = ruleObj.countryAttribute;
                                let country = $('[name="'+ countryAttr +'"]').val();
                                // nz or aus
                                if (country == 'NZ' || country == 'NZL') {
                                    return {
										message: 'This field is required',
										allowEmpty: false,
                                    };
                                } else {
                                    // not nz or aus, don't validate digits only
                                    return false;
                                }
                                // other countries?
                            };
                            break;
                        case 'requiredIfSuburb':
                            constraints[attribute].presence = function(value, attributes, attributeName, options, constraints) {
                                let countryAttr = ruleObj.countryAttribute;
                                let country = $('[name="'+ countryAttr +'"]').val();
                                // nz or aus
                                if (country == 'AU' || country == 'AUS') {
                                    return {
										message: 'This field is required',
										allowEmpty: false,
                                    };
                                } else {
                                    // not nz or aus, don't validate digits only
                                    return false;
                                }
                                // other countries?
                            };
                            break;
                        case 'requiredIfEmpty':
                            // required if the "reqElements" is empty
                            constraints[attribute].presence = function(value, attributes, attributeName, options, constraints) {
                                let reqEls = ruleObj.reqElements;
                                let isEmpty = false;

                                $.each(reqEls, function(i, name) {
                                    let reqEl = $('[name="'+ name +'"]').val();
                                    if (!reqEl) {
                                        isEmpty = true;
                                        return;
                                    }
                                });

                                if (isEmpty) {
                                    return {
										message: 'This field is required',
										allowEmpty: false,
                                    };
                                } else {
                                    return false;
                                }
                            };
                            break;
                        case 'alphanumeric':
                            constraints[attribute].format = {
                                pattern: ruleObj.regex || /^[a-zA-Z0-9 ]*$/,
                                message: 'Please use letters and numbers only',
                            };
                            break;
                        case 'address':
                            constraints[attribute].format = {
                                pattern: ruleObj.regex || /^[a-zA-Z0-9,.;:/\\\-'’ ]*$/,
                                message: 'The entered address contains an invalid character',
                            };
                            break;
						case 'address-name':
							constraints[attribute].format = function(value, attributes, attributeName, options, constraints) {
								const inValidAddressName = (window.addressList || []).find((address) => address.addressName === value);
                                if (inValidAddressName && $(input).is(':visible')) {
                                    return {
                                        pattern: /(.*?)/,
                                        message: 'The address already exists. Please update that address or choose different address.',
                                    };
                                }

                                return false;
                            };
							break;

                        case 'delivery-address':
                            constraints[attribute].format = function (value, attributes, attributeName, options, constraints) {
                                if (!$(form).find(`[name="${attributeName}"]`).hasClass('ignore-rule-delivery-address')){
                                    const data = Object.keys(window.AddressValidations || {}).reduce((acc, key) => {
                                        const message = window.AddressValidations[key] || '';
                                        ['\\b \\b'].forEach((patternType) => {
											const pattern = patternType.replace(/ /gi, key);
											window.AddressValidationsFinal = window.AddressValidationsFinal || {};
                                            window.AddressValidationsFinal[pattern] = message;
                                            acc.push({
                                                regex: new RegExp(pattern, 'ig'),
                                                format: {
                                                    pattern: /(.*?)/,
                                                    message: message,
                                                },
                                            });
                                        });
                                        return acc;
                                    }, []).find((validate) => {
										const inValid = validate.regex.test(value)
										return inValid
									});

                                    if (data) {
                                        return data.format;
                                    }
                                }
                            };
                            break;
                        default:
                            //
                    }
                }
            }
        }
    }

	// Hook up the form so we can prevent it from being posted
	form.addEventListener('submit', function(ev) {
        ev.preventDefault();
        // ignore hidden fields here if they are marked to ignore
		handleFormSubmit(form, ev);
	});

	// Hook up the inputs to validate on the fly
    for (let input of inputs) {
        if (!$(input).hasClass('skip-validation')) {
            input.addEventListener('change', function(ev) {
                checkValidateRequire(form);
                let errors = validate(form, constraints) || {};
                showErrorsForInput(this, errors[this.name]);
            });
        }
    }

    function handleFormSubmit(form, event) {
        checkValidateRequire(form);

		// validate the form against the constraints
		let errors = validate(form, constraints);
		// then we update the form to reflect the results
		showErrors(form, errors || {});
		if (!errors) {
            C.formSuccessCallback(form, event);
        } else {
            // skip validation for fields that are required but were hidden
            for (let attribute in errors) {
                if (errors.hasOwnProperty(attribute)) {
                    let inp = $('input[name='+ attribute +'], select[name='+ attribute +'], textarea[name='+ attribute +']');
                    let formGroup = inp.closest('.form-group, .form-check').eq(0);
                    if (inp.hasClass('ignore-validation') || !inp.is(':visible')) {
                        delete errors[attribute];
                        resetFormGroup(formGroup[0], inp[0]);
                    }
                }
            }
            if (Object.keys(errors).length === 0 && errors.constructor === Object) {
                C.formSuccessCallback(form, event);
            }
        }

        if (errorCB) errorCB(errors);
	}

    function checkValidateRequire(form) {
        for (const attribute in constraints) {
            const $input = $(form).find('input[name='+ attribute +'], select[name='+ attribute +'], textarea[name='+ attribute +']');
            const validationObj = $input.data('validation');
            if (validationObj.required && ($input.hasClass('ignore-require') || !$input.is(':visible'))) {
                constraints[attribute].presence = false;
            } else if (validationObj.required) {
                constraints[attribute].presence = {
                    message: validationObj.requiredMsg || 'This field is required',
                    allowEmpty: false
                };
            }
        }
    }

	// Updates the inputs with the validation errors
	function showErrors(form, errors) {
        // We loop through all the inputs and show the errors for that input
        let inputs = form.querySelectorAll('input[name], select[name], textarea[name]');
        for (let input of inputs) {
            // Since the errors can be null if no errors were found we need to handle that
            showErrorsForInput(input, errors && errors[input.name]);
        }
	}

	// Shows the errors for a specific input
	function showErrorsForInput(input, errors) {
        // This is the root of the input
        let formGroup;
        formGroup = closestParent(input.parentNode, 'form-group');
        // Find where the error messages will be insert into
        if (!formGroup) {
            formGroup = closestParent(input.parentNode, 'form-check');
        }
		// First we remove any old messages and resets the classes
		resetFormGroup(formGroup, input);

		// If we have errors
		if (errors) {
			// we first mark the group has having errors
            formGroup.classList.add('has-error');
            input.classList.add('has-error');
            // then we append all the errors
            for (let error of errors) {
                addError(formGroup, error);
            }
		} else {
			// otherwise we simply mark it as success
			formGroup.classList.add('has-success');
		}
	}

	// Recusively finds the closest parent that has the specified class
	function closestParent(child, className) {
		if (!child || child == document) {
			return null;
		}
		if (child.classList.contains(className)) {
			return child;
		} else {
			return closestParent(child.parentNode, className);
		}
	}

	function resetFormGroup(formGroup, input) {
		// Remove the success and error classes
        formGroup.classList.remove('has-error');
        input.classList.remove('has-error');
		formGroup.classList.remove('has-success');
        // and remove any old messages
        let els = formGroup.querySelectorAll('.error-message');
        for (let el of els) {
            el.parentNode.removeChild(el);
        }
	}

	// Adds the specified error with the following markup
	// <div class="error-message">[message]</div>
	function addError(formGroup, error) {
		let block = document.createElement('div');
		block.classList.add('error-message');
		block.innerText = error;
		formGroup.appendChild(block);
    }

    // remove errors if input field is required and empty on blur
	$(form).on('blur', 'input[data-validation], select[data-validation], textarea[data-validation]', function() {
		let inp = $(this);
		if (inp.val() == '') {
			inp.removeClass('has-error');
			inp.closest('.form-group').removeClass('has-error');
			inp.closest('.form-group').find('.error-message').remove();
		}
	});
}

export function removeErrors(form) {
	$(form).find('input[data-validation], select[data-validation], textarea[data-validation]')
		.removeClass('has-error')
		.closest('.form-group').removeClass('has-error')
		.find('.error-message').remove();
}

export function switchTheme(theme) {
	switch (theme) {
        // remove theme specific styles
        // remove theme specific styleguides
        case 'core':
            $('body').removeClass('is-bris is-rebel is-lng');
            $('body').find('.bris-theme, .rebel-theme, .lng-theme').hide();
            break;
        case 'bris':
            $('body').removeClass('is-rebel is-lng').addClass('is-bris');
            $('body').find('.core-theme, .rebel-theme, .lng-theme').hide();
            $('head').append('<link href="https://prep.briscoes.co.nz/globalassets/development/css/landingPages_v1.0.48.css" rel="stylesheet" type="text/css"/>'+
                            '<link href="https://prep.briscoes.co.nz/globalassets/development/css/briscoestheme-1.css" rel="stylesheet" type="text/css" />');
            $('#style-for-theme').attr('href', 'assets/css/style-briscoes.css');
            break;
        case 'rebel':
            $('body').removeClass('is-bris is-lng').addClass('is-rebel');
            $('body').find('.bris-theme, .core-theme, .lng-theme').hide();
            $('#style-for-theme').attr('href', 'assets/css/style-rebel.css');
            break;
        case 'lng':
            $('body').removeClass('is-bris is-rebel').addClass('is-lng');
            $('body').find('.bris-theme, .rebel-theme, .core-theme').hide();
            $('#style-for-theme').attr('href', 'assets/css/style-living.css');
            break;
        default:
            //
    }
}

export function fontLoader() {
    let theme = $('body').attr('class');
    let kitId;

    if (theme) {
        theme = theme.toLowerCase();
        if (theme.indexOf('is-bris') != -1) {
            kitId = 'hnr1onc';
        } else if (theme.indexOf('is-rebel') != -1) {
            kitId = 'iaf8bhz';
        } else if (theme.indexOf('is-lng') != -1) {
            kitId = 'hts5yck';
        }
    }

    if (kitId) {
        let scr = `
        <script id="${theme}-font">
            (function(d) {
            var config = {
                kitId: '${kitId}',
                scriptTimeout: 3000,
                async: true
            },
            h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
            })(document);
        </script>
        `;
        $('body').append(scr);
    }
}

export function countChar(el, maxCharacterSize) {
    if (maxCharacterSize) {
        let limit = parseInt(maxCharacterSize);
        if (el.val().length <= limit) {
           $(el).parent().find('.charNumCount .charNum').text(el.val().length);
        }
    } else {
        $(el).parent().find('.charNumCount .charNum').text(el.val().length);
    }
}

export function handleFFBreakingCols() {
	$(document).find('.megaMenuTab .linkList').each(function() {
		$(this).css({
			'page-break-inside': 'avoid',
		});
	});
}

export function isInView(el) {
	let rect = el[0].getBoundingClientRect();
	let elemTop = rect.top;
	// Only completely visible elements return true
	let isVisible = (elemTop <= window.innerHeight);
	return isVisible;
}

export function truncateText(string, limit) {
	if (string.length > limit) {
        return string.substring(0, limit) + '...';
    } else {
        return string;
    }
}

export function triggerDispatchEvent(el, event) {
	let ev;
	if (typeof (Event) === 'function') {
		ev = new Event(event, {
			'bubbles': true,
		});
	} else {
		ev = document.createEvent('Event');
		ev.initEvent(event, true, true);
	}
	el[0].dispatchEvent(ev);
}

export function addErrorMessage(input, error) {
    let block = document.createElement('div');
    let formGroup = input.parentElement;

    block.classList.add('error-message');
    block.innerText = error;
    input.classList.add('has-error');
    formGroup.classList.add('has-error');
    formGroup.appendChild(block);
}

export function removeErrorMessage(input) {
    let formGroup = input.parentElement;
    let errorEl = formGroup.querySelector('.error-message');

    input.classList.remove('has-error');
    formGroup.classList.remove('has-error');
    if (errorEl) errorEl.remove();
}

export function scrollTo(top, offset = 0) {
    $('html, body').animate({
        scrollTop: top - offset,
    }, 300);
}

export function getCurrentTheme() {
    let theme = $('body').attr('class');

    if (theme) {
        theme = theme.toLowerCase();
        if (theme.indexOf('is-bris') !== -1) {
            return 'is-bris';
        } else if (theme.indexOf('is-rebel') !== -1) {
            return 'is-rebel';
        } else if (theme.indexOf('is-lng') !== -1) {
            return 'is-lng';
        } else {
            console.warn(`No theme found. It's using Core style.`);
            return 'no-theme';
        }
    } else {
        console.warn(`No theme found. It's using Core style.`);
        return 'no-theme';
    }
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Add / Update a key-value pair in the URL query parameters
export function updateUrlParameter(uri, key, value) {
	// remove the hash part before operating on the uri
	let i = uri.indexOf('#');
	let hash = i === -1 ? '' : uri.substr(i);
	uri = i === -1 ? uri : uri.substr(0, i);

	let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
	let separator = uri.indexOf('?') !== -1 ? '&' : '?';

	if (!value) {
		// remove key-value pair if value is empty
		uri = uri.replace(new RegExp('([?&]?)' + key + '=[^&]*', 'i'), '');
		if (uri.slice(-1) === '?') {
			uri = uri.slice(0, -1);
		}
		// replace first occurrence of & by ? if no ? is present
		if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
	} else if (uri.match(re)) {
		uri = uri.replace(re, '$1' + key + '=' + value + '$2');
	} else {
		uri = uri + separator + key + '=' + value;
	}
	return uri + hash;
}

export function getWebsiteCountry() {
    let url = window.location.href;
    url = url.toLowerCase();
    if (url.indexOf('.co.nz') !== -1) {
        return 'nz';
    } else if (url.indexOf('.com.au') !== -1) {
        return 'au';
    } else {
        return 'nz';
    }
}

export function createSharingObj() {
    let title = document.title.replace('&amp;', 'and').replace('&', 'and');
    if (title) {
        window.addthis_share = {
            url: window.location.href,
            title: title,
        };
    }
}

// Throws weird error "Uncaught ReferenceError: regeneratorRuntime is not defined"
// So, put the "pushEmarsysData" function to utils.js instead of dataLayer.js
export function pushEmarsysData() {
	let $emarsysdata = $('#emarsysdata');
	if ($emarsysdata.length === 0) return;

	window.dataLayer = window.dataLayer || [];
	let dataLayerObj = {
		'event': 'emarsysDataPush',
	};

	let cartItems = $emarsysdata.data('cartitems');
	if (cartItems) {
		if (typeof cartItems === 'string') {
			cartItems = JSON.parse(cartItems);
		}
		dataLayerObj.cartItems = cartItems;
	}

	let email = $emarsysdata.data('login-email');
	if (email) {
		dataLayerObj.identifier = email;
	}

	window.dataLayer.push(dataLayerObj);
}

// https://stackoverflow.com/questions/1458724/how-do-i-set-unset-a-cookie-with-jquery
export function getCookie(name) {
    let nameEQ = encodeURIComponent(name) + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

export const BREAKPOINT = {
	XS: 0,
	SM: 576,
	MD: 768,
	LG: 992,
	XL: 1200
}

export const RECS_TYPE = {
	ALTERNATIVE: 'productAlternativesWidget',
	CROSS_SELL: 'productCrossSellsWidget',
	BASKET: 'basketWidget',
	HOME: 'homeWidget',
	SEARCH: 'searchWidget',
    MINI_CART: 'miniCartWidget',
    ADD_TO_CART: 'addToCartWidget',
}

export function isLoggedin() {
	return $('#emarsysdata').data('loginEmail');
}
// add more function like the above here

export function fixedOverviewBar() {
	function fixedOverviewOnScroll() {
		const $overviewBar = $('.pdp-info-heading');
		const $pdpInfo = $('.pdp-info');
		const overviewHeight = $overviewBar.outerHeight();
		let infoOffset = $pdpInfo.offset().top;
		let _currentScroll = $(window).scrollTop();
		const $header = $('.siteHeader');
		const headerHeight = $header.height();
		const stickyHeader = $header.hasClass('is-sticky');
		if (stickyHeader) {
			if (_currentScroll > (infoOffset - headerHeight - overviewHeight)) {
				$overviewBar.addClass('fixed');
				$overviewBar.css('top', headerHeight);
				$pdpInfo.css('padding-top', overviewHeight + 'px');
			} else {
				$overviewBar.removeClass('fixed');
				$overviewBar.css('top', '');
				$pdpInfo.css('padding-top', '');
			}
		} else {
			if (_currentScroll > infoOffset) {
				$overviewBar.addClass('fixed');
				$pdpInfo.css('padding-top', overviewHeight + 'px');
			} else {
				$overviewBar.removeClass('fixed');
				$pdpInfo.css('padding-top', '');
			}
		}

		let _currentSection = '';
		$('.js-scroll').each((index, section) => {
			let $section = $(section);
			const sectionTop = stickyHeader ? $section.offset().top - (overviewHeight + headerHeight + 10)
											: $section.offset().top - (overviewHeight + 10);
			if (_currentScroll >= sectionTop) {
				_currentSection = $section.attr('id');
			}
		});

		$overviewBar.find('ul li').each((index, li) => {
			let $li = $(li);
			$li.removeClass('active');
			if ($li.hasClass(_currentSection)) {
				$li.addClass('active');
			}
		});
	}
	fixedOverviewOnScroll();
	$(window).on('scroll', fixedOverviewOnScroll);
}

export function scrollToAnchor() {
	$('.pdp-info-heading ul li a').not('[href="#"]').on('click', function(e) {
		e.preventDefault();
		let target = $(this).attr('href');
		const overviewHeight = $('.pdp-info-heading').outerHeight();
		const $header = $('.siteHeader');
		const headerHeight = $header.height();
		const stickyHeader = $header.hasClass('is-sticky');
		let offsetTop = stickyHeader ? $(target).offset().top - (overviewHeight + headerHeight) : $(target).offset().top - overviewHeight;
		if (target) {
			$('html, body').animate({
				scrollTop: offsetTop,
			}, 1000);
		}
	});
}

export function getPartial(partial, params) {
	const paramArray = [];

	for (const key in params) {
		paramArray.push(`${key}="${params[key]}"`);
	}
	const template = `{{> ${partial} ${paramArray.join(' ')} }}`;
	return Handlebars.template(new Function('return ' + Handlebars.precompile(template))());
}

export function convertStringToHTML(str) {
	let parser = new DOMParser();
	let doc = parser.parseFromString(str, 'text/html');
	return doc.body;
}

export function showLoading() {
    $('.loading-spinner').addClass('is-active');
}

export function hideLoading() {
    $('.loading-spinner').removeClass('is-active');
}

export function dispatchEvent(selector, type, data) {
    const selectorEl = document.querySelector(selector);
    if (selectorEl) {
        const evt = new CustomEvent(type);
		evt.data = data;
        selectorEl.dispatchEvent(evt);
    }
}

export function isNullOrWhiteSpace(value) {
	return !value || !value.replace(/\s/gi, '').length;
}

/**
 * Customizing Screen-Set Error Messages
 * https://help.sap.com/docs/SAP_CUSTOMER_DATA_CLOUD/8b8d6fffe113457094a17701f63e3d6a/414faff370b21014bbc5a10ce4041860.html?locale=en-US&q=customLang
 */
export function showScreenSet(setting) {
    const EXPIRATION_DAY = 30;
    const globalCustomLang = _.get(window.gigya, 'thisScript.globalConf.customLang', {});

    setting.customLang = _.extend({
        account_temporarily_locked_out: CDC_ERROR_MESSAGE[CDC_ERROR_CODE.ACCOUNT_TEMPORARILY_LOCKED_OUT],
        email_already_exists: CDC_ERROR_MESSAGE[CDC_ERROR_CODE.UNIQUE_IDENTIFIER_EXISTS],
        login_identifier_exists: CDC_ERROR_MESSAGE[CDC_ERROR_CODE.LOGIN_IDENTIFIER_EXISTS],
    }, globalCustomLang);

    // Note: This setting is not supported on Safari.
    setting.sessionExpiration = 3600 * 24 * EXPIRATION_DAY;

    window.gigya && window.gigya.accounts.showScreenSet(setting);
}

export function replaceElemnt($element) {
    const $clone = $element.cloneNode(true);
    $element.parentNode.insertBefore($clone, $element.nextSibling);
    $element.remove();

    return $clone;
}

export function getStoreList(defaults = []) {
    // Sync store at region store popup at header.
    let storeList = [];
    $('.regionStorePopup-fallback .dropdown-menu .dropdown-item').each(function() {
        storeList = _.concat(storeList, $(this).data('store'));
    });

    return _.concat(defaults, _.sortBy(_.unionBy(storeList, 'storeId'), 'storeId'));
}

export function enableRenderStore() {
    return window.CDC_ENABLE_RENDER_STORE === undefined || window.CDC_ENABLE_RENDER_STORE;
}

export function getAddressFromCDC(data) {
    function getAddress(data) {
        const address = {
            addressName: data.addressName,
            addressType: data.addressType,
            billingDefault: data.billingDefault,
            city: data.city,
            companyName: data.companyName,
            countryCode: data.countryCode,
            countryName: data.countryName,
            firstName: data.firstName,
            lastName: data.lastName,
            shippingDefault: data.shippingDefault,
            state: data.state,
            addressLine1: data.addressLine_1,
            country: data.countryName,
            suburb: data.suburbs,
            postcode: data.postCode,
        };

        if (data.addressID) {
            address.addressId = data.addressID;
        }

        return address;
    }

    if (_.isArray(data)) {
        return data.map(getAddress);
    } else {
        return getAddress(data);
    }
}

export function getAddressFromOpti(data) {
    const customerAddressType = {
        2: 'Shipping',
        3: 'Shipping',
        4: 'Billing',
        5: 'Billing',
    };

    function getAddress(data) {
        const address = {
            addressID: data.AddressId,
            addressName: data.Name,
            addressType: customerAddressType[data.AddressType] || data.AddressType,
            billingDefault: data.BillingDefault,
            city: data.City,
            companyName: data.Organization,
            countryCode: data.CountryCode,
            countryName: data.CountryName,
            firstName: data.FirstName,
            lastName: data.LastName,
            shippingDefault: data.ShippingDefault,
            state: data.StateProvince,
            addressLine_1: data.Line1,
            suburbs: data.Line2,
            postCode: data.PostalCode,
        };

        return address;
    }

    if (_.isArray(data)) {
        return data.map(getAddress);
    } else {
        return getAddress(data);
    }
}

export function getRelatedVariants($relatedCollection = $('.relatedProducts')) {
    const relatedCollections = $.makeArray($relatedCollection.find('.relatedProducts__item:visible:not([data-sku=""])')) || [];

    return relatedCollections
        .map((item) => {
            const code = $(item).attr('data-sku');
            const quantity = $(item).find('.quantityInput input').val();

            return {
                code,
                quantity,
            };
        })
        .filter(({quantity}) => parseInt(quantity));
}

export function getColourSwatch(value) {
    const hexColours = value.split(',');
    if (hexColours.length === 1) {
        return `background-color:${hexColours[0]}`;
    } else if (hexColours.length === 2) {
        return `background: linear-gradient(135deg, ${hexColours[0]} 50%, ${hexColours[1]} 50%); border: 1px solid #000`;
    } else if (hexColours.length === 3) {
        return `background: conic-gradient(${hexColours[1]} 120deg, ${hexColours[2]} 120deg 240deg, ${hexColours[0]} 240deg 360deg); border: 1px solid #000`;
    }
    return '';
}

export function getDiscountText(discountCode) {
    return isNaN(discountCode) ? discountCode : `${discountCode}% OFF`;
}

export function messageScrollIntoView() {
    $('.has-error:visible')[0] && $('.has-error:visible')[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
}

export function getRecommendationsApi(api) {
    if (window.ShOW_PRODUCT_RECS_ADD_TO_CART) {
        return api || '';
    }

    return '';
}
export function stringToHtml(str) {
	const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
}

export function css(styleConfig = {}) {
	const style = Object.keys(styleConfig).map((key) => {
		return `${key}: ${styleConfig[key]} !important`;
	}).join('; ');
	return style;
}

export function getHotPrice(text = '') {
	return ['HOT PRICE', text].filter(data => !!data).join(' - ');
}

export function getStyle(configs = {}) {
	const mapStyle = {
		'Color': 'color',
		'color': 'color',
		'BackgroundColor': 'background-color',
		'background-color': 'background-color',
		'Background':'background',
		'background': 'background',
		'FontSize': 'font-size',
		'font-size': 'font-size',
		'FontWeight': 'font-weight',
		'font-weight': 'font-weight',
	};

	const style = Object.keys(configs).reduce((acc, key) => {
		const prop = mapStyle[key];
		if (prop) {
			acc.push(`${prop}: ${configs[key]}`);
		}

		return acc;
	}, []).join('; ');

	return style;
}

export function getDiscountWithClearanceBadgePrefixText(discountCode) {
	const prefixText = window.DISCOUNT_WITH_CLEARANCE_STYLE && window.DISCOUNT_WITH_CLEARANCE_STYLE.PrefixText ?
		`${window.DISCOUNT_WITH_CLEARANCE_STYLE.PrefixText} ` :
		'';

	if (isNaN(discountCode)) {
		return `${prefixText}${discountCode}`;
	} else {
		return `${prefixText}${discountCode}% OFF`;
	}
}

export function getDisclaimerTextColor() {
	if (window.DISCOUNT_WITH_CLEARANCE_STYLE && window.DISCOUNT_WITH_CLEARANCE_STYLE.DisclaimerTextColor) {
		return getStyle({ color: window.DISCOUNT_WITH_CLEARANCE_STYLE.DisclaimerTextColor});
	}
	return '';
}



// WEBPACK FOOTER //
// ./utils.js